let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("gWzc8")]).then(() => parcelRequire('2i4Yq'));